export const Property = (propertyData) => ({
    ...propertyData,
    isSystemProperty(){
        return !propertyData.organisationId;
    },
    isSportProperty(){
        return !!propertyData.sportType;
    }
});
